export default __webpack_public_path__ + "static/media/AnjeloBG.5d58eaf1.jpg";